/**
 * promotions.js — Lebua Thai Promotion Data
 *
 * THIS IS THE ONLY FILE YOU NEED TO EDIT when promotions change.
 *
 * Each promotion object:
 * {
 *   id:        unique string key
 *   title:     display name
 *   tag:       short badge label (e.g. "Every Friday", "Limited Time")
 *   tagColor:  "gold" | "rose" | "cyan" — controls badge colour
 *   content:   description paragraph shown on the card
 *   image:     imported image (add import at top of this file)
 *   ctaLabel:  (optional) button label — if provided, button links to ctaHref
 *   ctaHref:   (optional) URL or path for the CTA button
 *   active:    true = show prominently | false = hide card entirely
 *   startDate: (optional) "YYYY-MM-DD" — card hides before this date
 *   endDate:   (optional) "YYYY-MM-DD" — card hides after this date
 * }
 *
 * Date rules:
 *  - Omit startDate/endDate for evergreen promotions (Happy Hour, etc.)
 *  - Set endDate for seasonal promos — they disappear automatically.
 *  - Set active: false to manually hide any promotion instantly.
 */

import lunchSetImg    from '../assets/lunch.jpg';
import lunchSet2Img   from '../assets/lunch2.jpg';
import lunchSet3Img   from '../assets/lunch3.jpg';
import wineDinnerImg  from '../assets/P11.jpg';
import ladysNightImg  from '../assets/P12.jpg';
import thaiDanceImg   from '../assets/P5.jpg';
import happyHourImg   from '../assets/hp.jpg';
import singaporeSlingImg from '../assets/sgsling.jpg';
import valentinesImg  from '../assets/P13.jpg';
import chineseNewYearImg from '../assets/P14.jpg';

const promotions = [
  {
    id: 'ladys-night',
    title: "Lady's Night",
    tag: 'Every Friday',
    tagColor: 'rose',
    content:
      "Clock out, dress up, and step into the weekend at Lebua Thai's Ladies' Night. Chilled vibes, cocktail moments, and a night made just for you — every Friday, 5:30 PM to 10 PM.",
    image: ladysNightImg,
    active: true,
  },
  {
    id: 'happy-hour',
    title: 'Happy Hour',
    tag: 'Mon – Fri',
    tagColor: 'gold',
    content:
      'Unwind after work with our Happy Hour deals. Available every Monday to Friday from 5:00 PM – 7:00 PM.',
    image: happyHourImg,
    active: true,
  },
  {
    id: 'lunch-set',
    title: 'Lunch Set Promotion',
    tag: 'Mon – Fri',
    tagColor: 'gold',
    content:
      'Enjoy a curated lunch set at a great price. Available every Monday to Friday from 11:30 AM – 2:30 PM.',
    images: [lunchSetImg, lunchSet2Img, lunchSet3Img],
    active: true,
  },
  {
    id: 'singapore-sling',
    title: 'Singapore Sling 1-for-1',
    tag: 'Sat & Sun',
    tagColor: 'cyan',
    content:
      "Sip into Singapore's vibrant spirit with the iconic Singapore Sling — a timeless blend of tropical elegance and bold flavour. Available all day every Saturday & Sunday.",
    image: singaporeSlingImg,
    active: true,
  },
  {
    id: 'wine-dinner',
    title: 'Wine Dinner Event',
    tag: 'Monthly',
    tagColor: 'gold',
    content:
      'We host an exclusive Wine Dinner Event once a month, accommodating up to 40 guests. Check our social media for upcoming dates and our exquisite wine list on the menu page.',
    image: wineDinnerImg,
    active: true,
  },
  {
    id: 'thai-dance',
    title: 'Traditional Thai Dance',
    tag: 'Alternate Fridays',
    tagColor: 'gold',
    content:
      'Immerse yourself in an authentic cultural experience every alternate Friday at 7:30 PM. Live Thai dance performance blending exquisite cuisine with vibrant artistry.',
    image: thaiDanceImg,
    active: true,
  },
  // ── Seasonal / time-limited promotions ──────────────────────────
  // Set endDate — they auto-hide when the date passes.
  // Set active: false to hide immediately without deleting.
  {
    id: 'valentines',
    title: "Valentine's Day Special",
    tag: 'Limited Time',
    tagColor: 'rose',
    content:
      "Celebrate love with an unforgettable dining experience at Lebua Thai. Indulge in a specially curated menu designed to ignite passion and delight your senses.",
    image: valentinesImg,
    startDate: '2026-02-09',
    endDate:   '2026-02-14',
    active: true,
  },
  {
    id: 'chinese-new-year',
    title: 'Chinese New Year Celebration',
    tag: 'Gong Xi Fa Cai',
    tagColor: 'rose',
    content:
      'Celebrate the Lunar New Year with a festive dining experience at Lebua Thai. Special menu items, decorations, and a warm atmosphere that captures the spirit of the season.',
    image: chineseNewYearImg,
    startDate: '2026-02-09',
    endDate:   '2026-02-28',
    active: true,
  },
];

export default promotions;
